var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgMicrosoftIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 0h7.611v7.611H.5V0z",
    fill: "#F65314"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.889 0H16.5v7.611H8.889V0z",
    fill: "#7FBB41"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M.5 8.388l7.611.001V16H.5V8.388z",
    fill: "#00A1F1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.889 8.389H16.5V16H8.889V8.389z",
    fill: "#FB0"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZwogICAgICB3aWR0aD0iMTciCiAgICAgIGhlaWdodD0iMTYiCiAgICAgIHZpZXdCb3g9IjAgMCAxNyAxNiIKICAgICAgZmlsbD0ibm9uZSIKICAgICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICAgPgogICAgICA8cGF0aAogICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTAuNSAwSDguMTExNDJMOC4xMTA4MyA3LjYxMTQySDAuNVYwWiIKICAgICAgICBmaWxsPSIjRjY1MzE0IgogICAgICAvPgogICAgICA8cGF0aAogICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTguODg4NTQgMEgxNi41QzE2LjUgMi41MzcxNCAxNi41MDA0IDUuMDc0MjggMTYuNDk5NSA3LjYxMTQyQzEzLjk2MjggNy42MTA5OCAxMS40MjU3IDcuNjExNDIgOC44ODg5OCA3LjYxMTQyQzguODg4MSA1LjA3NDI4IDguODg4NTQgMi41MzcxNCA4Ljg4ODU0IDBaIgogICAgICAgIGZpbGw9IiM3RkJCNDEiCiAgICAgIC8+CiAgICAgIDxwYXRoCiAgICAgICAgZmlsbC1ydWxlPSJldmVub2RkIgogICAgICAgIGNsaXAtcnVsZT0iZXZlbm9kZCIKICAgICAgICBkPSJNMC41IDguMzg4MThDMy4wMzcxNCA4LjM4OTA3IDUuNTc0MjggOC4zODc4OSA4LjExMTQyIDguMzg5MDdDOC4xMTE4NiAxMC45MjYyIDguMTExNDIgMTMuNDYyOSA4LjExMTQyIDE2SDAuNVY4LjM4ODE4WiIKICAgICAgICBmaWxsPSIjMDBBMUYxIgogICAgICAvPgogICAgICA8cGF0aAogICAgICAgIGZpbGwtcnVsZT0iZXZlbm9kZCIKICAgICAgICBjbGlwLXJ1bGU9ImV2ZW5vZGQiCiAgICAgICAgZD0iTTguODg4OTkgOC4zODkwMUMxMS40MjU3IDguMzg4MTMgMTMuOTYyOCA4LjM4ODU3IDE2LjUgOC4zODg1N1YxNkg4Ljg4ODU1QzguODg4OTkgMTMuNDYyOCA4Ljg4ODExIDEwLjkyNTcgOC44ODg5OSA4LjM4OTAxWiIKICAgICAgICBmaWxsPSIjRkZCQjAwIgogICAgICAvPgogICAgPC9zdmc+";
export { SvgMicrosoftIcon as ReactComponent };